import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Modal, Box } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./EmergencyASNApprovalModal.module.css";


const EmergencyASNApprovalModal = ({
  title,
  open,
  handleClose,
  rowsData,
  handleSubmit,
  lineBackgroundColor,
  cancelButtonText = "REJECT",
  submitButtonText = "APPROVE",
}) => {
  const [comment, setComment] = useState("");
  const [error, setError] = useState(null);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={styles.formContainer}>
          <div className={styles.formTitle}>
            <span>{title}</span>

            <div
              className={styles.formlLineDiv}
              style={{ backgroundColor: lineBackgroundColor }}
            />

            <button
              type="button"
              className={styles.closeButton}
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>
          <div className={styles.subHeading}>
            Note: This will Approve or Reject Emergency ASN
          </div>
          <Box bgcolor="#dadada3d" paddingTop="1px" paddingBottom="1px">
            <div className={styles.defineRow}>
              <label className={clsx(styles.lb1, styles.selLabel)}>
                Comment
              </label>
              <textarea
                className={styles.textfield}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>
            <div className={styles.errorText}>
              <em>{error}</em>
            </div>
          </Box>
          <div className={styles.bottomRow}>
            <button
              className={styles.cancelBt}
              onClick={() => {
                if (comment) {
                  handleSubmit(rowsData, comment, "REJECTED");
                  handleClose();
                } else {
                  setError("*Please Enter Comment");
                }
              }}
            >
              {cancelButtonText}
            </button>
            <span>
              <button
                onClick={() => {
                  if (comment) {
                    handleSubmit(rowsData, comment, "APPROVED");
                    handleClose();
                  } else {
                    setError("*Please Enter Comment");
                  }
                }}
                className={styles.submitBt}
                data-testid="assign-date-button"
              >
                {submitButtonText}
              </button>
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};

EmergencyASNApprovalModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  rowsData: PropTypes.arrayOf(
    PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      data: PropTypes.array.isRequired,
      filteredData: PropTypes.array.isRequired,
    }),
  ),
  handleSubmit: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  lineBackgroundColor: PropTypes.string,
};

export default EmergencyASNApprovalModal;
